import React from 'react';
import { SectionWrapper } from '../../theme/layouts/MainLayout';
import { techBlack } from '../../common/utils/constant';
import "./oaPolicy.scss";

function OaPolicy() {
  return (
    <div>
      <SectionWrapper bg={techBlack}>
        <div className='policy-wrapper'>
          <h2 className='policy-content-title'>Website Analytics Services</h2>
          <h3 className='policy-subtitle pt-4'> Effective February 1, 2022</h3>
          <p className='policy-subtext pt-2 m-0'>Best Buy Ads is here to help you get your brand in front of the consumers you want to reach. To help us do this, we need to understand the traffic and user experiences on our site. This Best Buy Ads website uses digital analytics tools including Google Analytics, which uses cookies—small text files—to identify your device. This cookie information, including your IP address and the pages you visit on bestbuyads.com is collected by Google and stored on Google servers. This information helps Best Buy Ads understand your use of the site. You can read more about Google Analytics and Google’s use of this cookie data <a href='https://policies.google.com/technologies/partner-sites' target='_blank' rel="noopener noreferrer" className='energy-link-yellow text-decoration-none'>here</a>. The Google Analytics Opt-out Browser Add-on is available <a href='https://tools.google.com/dlpage/gaoptout' target='_blank' rel="noopener noreferrer" className='energy-link-yellow text-decoration-none'>here</a>.</p>
        </div>
      </SectionWrapper>
    </div>
  )
}

export default OaPolicy